import { render, staticRenderFns } from "./UpdateGrantPopUp.vue?vue&type=template&id=666a1ce0&"
import script from "./UpdateGrantPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateGrantPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports